import { IClaioSchemaImageSource } from "../../../domain/claio";
import { AbstractSource } from "../../drawing";

export class ClaioSchemaImageSource extends AbstractSource implements IClaioSchemaImageSource {
  constructor(getToken: () => string, public templateId: number, public groupId: number, public itemId: number) {
    super(getToken);
  }

  protected getSource(): string {
    return "api/claio/template/" + this.templateId + "/group/" + this.groupId + "/item/" + this.itemId + "/image?token=" + this.token;
  }
  
  get thumbnailSource(): string {
    return "api/claio/template/" + this.templateId + "/group/" + this.groupId + "/item/" + this.itemId + "/thumbnail?token=" + this.token;
  }

  clone(): ClaioSchemaImageSource {
    return new ClaioSchemaImageSource(this._getToken, this.templateId, this.groupId, this.itemId);
  }
}
